import { instance } from "libs/api";

import { ApiRoutesWarehouses } from "../../constants";
import { IWarehouse } from "../../warehouses.types";

export const requestGetWarehouses = async (): Promise<IWarehouse[]> => {
  return await instance.get(ApiRoutesWarehouses.Warehouses);
};
